import insideBackground from '../images/datson-tattoo-inside.jpeg';
// import drawBackground from '../images/studio_background_2.JPG'
import hinh1 from '../images/studio1.jpeg';
import hinh2 from '../images/studio2.jpeg';
import hinh3 from '../images/studio3.jpeg';
import hinh4 from '../images/studio4.jpeg';
import hinh5 from '../images/studio5.jpeg';
import hinh6 from '../images/studio6.jpeg';
import hinh7 from '../images/studio7.jpeg';
import hinh8 from '../images/studio8.jpeg';
import nhom1 from '../images/workcuaartist9.jpg';
import nhom2 from '../images/workcuaartist.jpg';
import nhom3 from '../images/workcuaartist10.jpg';
import nhom4 from '../images/workcuaartist1.jpg';
import nhom5 from '../images/workcuaartist11.jpg';
import nhom6 from '../images/workcuaartist12.jpg';
import nhom7 from '../images/workcuaartist2.jpg';
import nhom8 from '../images/workcuaartist13.jpg';
import nhom9 from '../images/workcuaartist3.jpg';
import nhom10 from '../images/workcuaartist14.jpg';
import nhom11 from '../images/workcuaartist15.jpg';
import nhom12 from '../images/workcuaartist16.jpg';
import nhom13 from '../images/workcuaartist17.jpg';
import nhom14 from '../images/workcuaartist18.jpg';
import nhom15 from '../images/workcuaartist19.jpg';
import nhom16 from '../images/workcuaartist20.jpg';
import nhom17 from '../images/workcuaartist21.jpg';
import nhom18 from '../images/workcuaartist22.jpg';
import nhom19 from '../images/workcuaartist23.jpg';
import { useLanguage } from './LanguageContext';

function Studio() {
	const { language } = useLanguage();
	return (
		<>
			{language === 'en' ? (
				<>
					<section
						className='relative bg-cover bg-center bg-no-repeat w-full min-h-screen flex justify-center items-center animate-fadeIn'
						style={{ backgroundImage: `url(${insideBackground})` }}>
						<div className='absolute inset-0 bg-black opacity-50'></div>

						<h1 className='relative text-white text-4xl md:text-6xl font-bold z-10 text-center'>
							<section
								className='relative bg-cover bg-center bg-no-repeat w-full min-h-screen flex justify-center items-center animate-fadeIn'
								style={{ backgroundImage: `url(${insideBackground})` }}>
								<div className='absolute inset-0 bg-black opacity-50'></div>

								<h1 className='relative text-white text-4xl md:text-6xl font-bold z-10 text-center avenir'>
									"Honoring the aesthetics<br></br> of human body and soul
									throught tattoo"
								</h1>
							</section>
						</h1>
					</section>
					<div className='flex flex-col space-y-5'>
						<section className='dark:bg-darkBrown dark:text-gray-100 py-60 flex flex-col space-y-5 '>
							<h2 className='relative text-white text-2xl md:text-5xl font-bold z-10 px-4 text-center avenir'>
								Datson Studio is a space for experiencing contemporary tattoo
								art, with personalized tattoo designs that embody timeless
								aesthetics.
							</h2>
							<section data-aos='fade-up' className='py-6 '>
								<div className='container flex flex-col justify-center p-4 mx-auto'>
									<div className='grid grid-cols-1 gap-4 lg:grid-cols-3 sm:grid-cols-2'>
										<img
											className='object-cover w-full dark:bg-gray-500 aspect-square'
											src={hinh1}
											alt='Datson Studio interior'
										/>
										<img
											className='object-cover w-full dark:bg-gray-500 aspect-square'
											src={hinh2}
											alt='Datson Studio workspace'
										/>
										<img
											className='object-cover w-full dark:bg-gray-500 aspect-square'
											src={hinh3}
											alt='Datson Studio private tattoo room'
										/>
										<img
											className='object-cover w-full dark:bg-gray-500 aspect-square'
											src={hinh4}
											alt='Datson Studio tattoo equipment area'
										/>
										<img
											className='object-cover w-full dark:bg-gray-500 aspect-square'
											src={hinh5}
											alt='Datson Studio consultation space'
										/>
										<img
											className='object-cover w-full dark:bg-gray-500 aspect-square'
											src={hinh6}
											alt='Datson Studio artwork display'
										/>
										<img
											className='object-cover w-full dark:bg-gray-500 aspect-square'
											src={hinh7}
											alt='Datson Studio tattoo session space'
										/>
										<img
											className='object-cover w-full dark:bg-gray-500 aspect-square'
											src={hinh8}
											alt='Datson Studio gallery'
										/>
									</div>
								</div>
							</section>
							<h2 className='relative text-white text-2xl md:text-5xl font-bold z-10 px-4 py-20 text-center avenir'>
								In addition, the studio offers forms of education, connection,
								collaboration, and art. <br /> Experience a private tattoo
								session with your own tattoo artist at our studio. <br /> Datson
								Studio - Private Tattoo Studio in Hoc Mon - Northwest Saigon
							</h2>
							<div data-aos='fade-up' className='container mx-auto py-8'>
								<div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4'>
									<div className='relative group'>
										<img
											src={nhom1}
											alt='Tattoo artwork by a Datson Studio artist'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom2}
											alt='Datson Studio artist tattoo work'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom3}
											alt='Finished tattoo artwork from Datson Studio'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom4}
											alt='Detailed tattoo artwork by a studio artist'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom5}
											alt='Datson Studio tattoo gallery piece'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom6}
											alt='Custom tattoo artwork from Datson Studio'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom7}
											alt='Tattoo artist work at Datson Studio'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom8}
											alt='Datson Studio tattoo portfolio'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom9}
											alt='Tattoo artwork gallery'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom10}
											alt='Datson Studio artist portfolio tattoo'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom11}
											alt='Custom tattoo design completed by a studio artist'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom12}
											alt='Datson Studio tattoo artwork showcase'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom13}
											alt='Tattoo portfolio artwork from Datson Studio'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom14}
											alt='Artist tattoo work gallery'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom15}
											alt='Datson Studio completed tattoo artwork'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom16}
											alt='Custom tattoo work by Datson Studio'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom17}
											alt='Datson Studio artist work gallery'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom18}
											alt='Tattoo artwork completed at Datson Studio'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom19}
											alt='Datson Studio tattoo portfolio artwork'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
								</div>
							</div>
						</section>
					</div>
				</>
			) : (
				<>
					<section
						className='relative bg-cover bg-center bg-no-repeat w-full min-h-screen flex justify-center items-center animate-fadeIn'
						style={{ backgroundImage: `url(${insideBackground})` }}>
						<div className='absolute inset-0 bg-black opacity-50'></div>

						<h1 className='relative text-white text-4xl md:text-6xl font-bold z-10 text-center'>
							<section
								className='relative bg-cover bg-center bg-no-repeat w-full min-h-screen flex justify-center items-center animate-fadeIn'
								style={{ backgroundImage: `url(${insideBackground})` }}>
								<div className='absolute inset-0 bg-black opacity-50'></div>

								<h1 className='relative text-white text-4xl md:text-6xl font-bold z-10 text-center avenir'>
									"Tôn vinh tính thẩm mỹ
									<br /> của cơ thể và tâm hồn con người thông qua nghệ thuật
									xăm hình"
								</h1>
							</section>
						</h1>
					</section>
					<div className='flex flex-col space-y-5'>
						<section className='dark:bg-darkBrown dark:text-gray-100 py-60 flex flex-col space-y-5 '>
							<h2 className='relative text-white text-2xl md:text-5xl font-bold z-10 px-4 text-center avenir'>
								Datson Studio là một không gian trải nghiệm nghệ thuật xăm hình
								đương đại, cùng những thiết kế hình xăm được cá nhân hoá thể
								hiện tính thẩm mỹ vượt thời gian
							</h2>
							<section data-aos='fade-up' className='py-6 '>
								<div className='container flex flex-col justify-center p-4 mx-auto'>
									<div className='grid grid-cols-1 gap-4 lg:grid-cols-3 sm:grid-cols-2'>
										<img
											className='object-cover w-full dark:bg-gray-500 aspect-square'
											src={hinh1}
											alt='Datson Studio interior'
										/>
										<img
											className='object-cover w-full dark:bg-gray-500 aspect-square'
											src={hinh2}
											alt='Datson Studio workspace'
										/>
										<img
											className='object-cover w-full dark:bg-gray-500 aspect-square'
											src={hinh3}
											alt='Datson Studio private tattoo room'
										/>
										<img
											className='object-cover w-full dark:bg-gray-500 aspect-square'
											src={hinh4}
											alt='Datson Studio tattoo equipment area'
										/>
										<img
											className='object-cover w-full dark:bg-gray-500 aspect-square'
											src={hinh5}
											alt='Datson Studio consultation space'
										/>
										<img
											className='object-cover w-full dark:bg-gray-500 aspect-square'
											src={hinh6}
											alt='Datson Studio artwork display'
										/>
										<img
											className='object-cover w-full dark:bg-gray-500 aspect-square'
											src={hinh7}
											alt='Datson Studio tattoo session space'
										/>
										<img
											className='object-cover w-full dark:bg-gray-500 aspect-square'
											src={hinh8}
											alt='Datson Studio gallery'
										/>
									</div>
								</div>
							</section>
							<h2 className='relative text-white text-2xl md:text-5xl font-bold z-10 px-4 py-20 text-center avenir'>
								Bên cạnh đó Studio còn đem đến các hình thức giáo dục, kết nối,
								hợp tác, nghệ thuật. <br /> Trải nghiệm xăm hình riêng tư cùng
								nghệ sĩ xăm hình của riêng bạn tại studio của chúng tôi
								<br /> Datson Studio - Studio Xăm Hình Riêng Tư tại Hóc Môn -
								Tây Bắc Sài Gòn
							</h2>
							<div data-aos='fade-up' className='container mx-auto py-8'>
								<div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4'>
									<div className='relative group'>
										<img
											src={nhom1}
											alt='Tattoo artwork by a Datson Studio artist'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom2}
											alt='Datson Studio artist tattoo work'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom3}
											alt='Finished tattoo artwork from Datson Studio'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom4}
											alt='Detailed tattoo artwork by a studio artist'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom5}
											alt='Datson Studio tattoo gallery piece'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom6}
											alt='Custom tattoo artwork from Datson Studio'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom7}
											alt='Tattoo artist work at Datson Studio'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom8}
											alt='Datson Studio tattoo portfolio'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom9}
											alt='Tattoo artwork gallery'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom10}
											alt='Datson Studio artist portfolio tattoo'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom11}
											alt='Custom tattoo design completed by a studio artist'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom12}
											alt='Datson Studio tattoo artwork showcase'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom13}
											alt='Tattoo portfolio artwork from Datson Studio'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom14}
											alt='Artist tattoo work gallery'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom15}
											alt='Datson Studio completed tattoo artwork'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom16}
											alt='Custom tattoo work by Datson Studio'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom17}
											alt='Datson Studio artist work gallery'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom18}
											alt='Tattoo artwork completed at Datson Studio'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
									<div className='relative group'>
										<img
											src={nhom19}
											alt='Datson Studio tattoo portfolio artwork'
											className='w-full h-auto object-cover rounded-lg shadow-lg'
										/>
									</div>
								</div>
							</div>
						</section>
					</div>
				</>
			)}
		</>
	);
}

export default Studio;
